import { useQuery } from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { Candidate } from '../types/candidate.types';

interface UseCandidateReturn {
  candidate: Candidate | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCandidate(id: string | undefined): UseCandidateReturn {
  const query = useQuery({
    queryKey: ['candidate', id],
    queryFn: () => candidateService.getCandidateById(id!),
    enabled: !!id,
  });

  return {
    candidate: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
